import { render, staticRenderFns } from "./EditMessageTemplate.vue?vue&type=template&id=45e61281&scoped=true&"
import script from "./EditMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./EditMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditMessageTemplate.vue?vue&type=style&index=0&id=45e61281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e61281",
  null
  
)

export default component.exports